import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
// import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

import filters from '@/filters'
Vue.use(filters)

import authService from './auth/auth.service'
import { can } from './libs/acl/actionProtection'
import { is } from './libs/acl/actionProtection'
import { hasUserpref } from './libs/acl/toolTipProtection'


import VueFormWizard from 'vue-form-wizard'


// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)


Vue.use(VueFormWizard)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.filter('formatDate', function(val: string) { 
  return new Date(val).toLocaleDateString()
});

Vue.config.productionTip = false
Vue.prototype.$authService = authService
Vue.prototype.$can = can.canActivate
Vue.prototype.$is = is.hasFonction
Vue.prototype.$hasUserpref = hasUserpref.hasUserPreference

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
